import { TextField } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { get } from "lodash";
import { DropzoneArea } from "material-ui-dropzone";
import { useMutation, useNotify } from "ra-core";
import React from "react";
import { Delivery } from "../../../types";
import { convertIsoToLocale } from "../../../utils/date";
import { deliveryActions } from "../util";

interface Props {
  record: Delivery;
}
const StartDeliveryDialog: React.FC<Props> = (props) => {
  const { record: delivery } = props;
  const [open, setOpen] = React.useState(false);
  const [pickupNote, setPickupNote] = React.useState("");
  const [pickedImages, setPickedImages] = React.useState<
    { url: string; type: string }[]
  >([]);
  const notify = useNotify();
  const pickedTime = new Date().toISOString();
  const pickedLocationId = get(delivery, "product_instance.location_id");

  const convertFileToBase64 = (file: File) => {
    var reader = new FileReader();
    return new Promise((resolve) => {
      reader.readAsDataURL(file);
      reader.onloadend = function () {
        var base64data = reader.result;
        resolve(base64data);
      };
    });
  };

  const handleSelectFile = async (files: File[]) => {
    // convert file to base64
    const convertAll = async (files: File[]) =>
      Promise.all(
        files.map(async (file: File) => {
          return await convertFileToBase64(file);
        })
      );

    convertAll(files)
      .then((base64s) =>
        base64s.map((base64) => ({
          url: base64,
          type: "image",
        }))
      )
      .then((picked_images) =>
        setPickedImages(picked_images as { url: string; type: string }[])
      );
  };

  const [handleAccept] = useMutation(
    {
      type: "update",
      resource: "deliveries",
      payload: {
        id: delivery.id ?? "",
        data: {
          action: deliveryActions.START,
          picked_time: pickedTime,
          picked_location_id: pickedLocationId,
          pickup_note: pickupNote,
          picked_images: pickedImages,
        },
      },
    },
    {
      onSuccess: () => {
        notify(`Successfully start a Delivery Order.`, "info");
        setOpen(false);
        setPickupNote("");
        setPickedImages([]);
      },
      onFailure: (error) => notify(`Error: ${error.message}`, "warning"),
    }
  );

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setPickupNote("");
    setPickedImages([]);
  };

  const handlePickupNoteChange = (
    event: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    setPickupNote(event.target.value);
  };

  return (
    <>
      <Button color="primary" onClick={handleClickOpen} size={"small"}>
        Start Delivery
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Start Delivery"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Please confirm to start Delivery.
            <br />
            <pre>
              Delivery ID: {delivery.id}
              <br />
              Product:{" "}
              {`${delivery.product_instance.product.name} (${delivery.product_instance.name})`}
              <br />
              Pickup Location: {delivery.product_instance.location.name}
              <br />
              Destination Location: {delivery.target_location.name}
              <br />
              Deliver Before:{" "}
              {convertIsoToLocale(delivery.target_delivery_time)}
            </pre>
          </DialogContentText>

          <TextField
            margin="dense"
            id="pickup-note"
            label="Pickup Note (Optional)"
            multiline
            rows={4}
            fullWidth
            variant="outlined"
            value={pickupNote}
            onChange={handlePickupNoteChange}
            style={{ marginTop: 16, marginBottom: 16 }}
          />

          <DropzoneArea
            filesLimit={10}
            onChange={handleSelectFile}
            dropzoneText="Add pickup photos (Optional)"
          />

          {pickedImages.length > 0 && (
            <div style={{ marginTop: 8 }}>
              <strong>Selected photos: {pickedImages.length}</strong>
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">
            Back
          </Button>
          <Button onClick={handleAccept} color="primary" autoFocus>
            Confirm Start Delivery
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default StartDeliveryDialog;
